import React from 'react';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import includes from 'lodash/includes';
import {push as changeURL} from 'react-router-redux';

import {productListConfig} from './config.js';
import Button from '~/components/common/Button';
import store from '~/store';
import Input from '~/components/pages/MyAccount/share/Input';
import {regEmail, regZip, regPhone, regDot, regMc} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {getFetchedJSON} from '~/misc/fetch';
import {formatPhone, formatNumberOnly} from '~/misc/formatPhone';
import {track} from '~/misc/metrics';
import {toastChange} from '~/modules/toast/actions';
import {centTo$} from '~/misc/formatMoney';

import css from './index.css';
import sharedCss from '../index.css';


class BasicInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      haveRead: false,
      readError: '',
      showDotInput: true,
      productList: [],
      formData: {
        companyMc: '',
        companyDot: '',
        companyName: '',
        basicFirstName: '',
        basicLastName: '',
        basicPhone: '',
        basicIdentity: '',
      },
      formControl: {
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.changeDotOrMC = this.changeDotOrMC.bind(this);
    this.changeReadValue = this.changeReadValue.bind(this);
    this.gotToNext = this.gotToNext.bind(this);
    this.blurDotMc = this.blurDotMc.bind(this);
    this.filterEmptyInputVal = this.filterEmptyInputVal.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.changeNavItem(this.state.currentStep);
    this.initPageData();
  }

  render() {
    const formControl = this.state.formControl;
    const formData = this.state.formData;
    const productList = this.state.productList;
    const planModes = this.props.hp.hpPlanInfo.data;

    return (
      <div className={css.wrap}>
        <div className={cs(css.partProduct)}>
          {
            productList.map((item, index) => (
              <div key={index} className={cs(css.card)}>
                <div
                  className={css.productMask}
                  // data-product={planModes[index].grade_option.key}
                />
                <div className={cs(css.cardName, css.cardSelectedName)}>limited-time offer only from</div>
                <div className={css.cardPrice}>
                  <span className={css.presentPrice}>{`$${centTo$(planModes[index].discount_price)}`}</span>
                  <span>
                    <em className={cs(css.lineThrough, css.hide)}>
                      {`$ ${centTo$(planModes[index].origin_price)}`}
                    </em>
                    per user/mo
                  </span>
                </div>
                <div className={css.detailWrap}>
                  <p className={css.proTit}>Order Summary</p>
                  <h3>{item.planTit}</h3>
                  <p className={css.info}>
                    {
                      item.planInfo
                    }
                  </p>
                </div>
              </div>
            ))
          }
        </div>
        <div className={css.formWrap}>
          <form>
            <Input
              mods={['floatLef', 'half']}
              title={'First Name'}
              label={'basicFirstName'}
              type='text'
              defaultValue={formData.basicFirstName || ''}
              fnChange={this.handleChange}
              fnBlur={this.handleBlur}
              error={formControl.basicFirstName ? formControl.basicFirstName.error : ''}
            />
            <Input
              mods={['floatRigt', 'half']}
              title={'Last Name'}
              label={'basicLastName'}
              type='text'
              defaultValue={formData.basicLastName || ''}
              fnChange={this.handleChange}
              fnBlur={this.handleBlur}
              error={formControl.basicLastName ? formControl.basicLastName.error : ''}
            />
            <div className={cs(css.mobileLeftInput, css.mobileInput)}>
              <Input
                mods={['floatLef', 'strench']}
                title={'Phone'}
                label={'basicPhone'}
                type='phone'
                defaultValue={formData.basicPhone || ''}
                fnChange={this.handleBlur}
                fnBlur={this.handleBlur}
                error={formControl.basicPhone ? formControl.basicPhone.error : ''}
              />
            </div>
            <div className={cs(css.mobileRightInput, css.mobileInput)}>
              <Input
                mods={['floatLef', 'strench']}
                title={'Identity'}
                label={'basicIdentity'}
                type='text'
                defaultValue={formData.basicIdentity || ''}
                placeholder='Fleet manager / Ind. owner operator …'
                fnChange={this.handleChange}
                fnBlur={this.handleBlur}
                error={formControl.basicIdentity ? formControl.basicIdentity.error : ''}
              />
            </div>
            <div className={cs(css.mobileLeftInput, css.mobileInput)}>
              <Input
                mods={['floatLef', 'strench']}
                title={'Company'}
                label={'companyName'}
                defaultValue={formData.companyName || ''}
                fnChange={this.handleChange}
                fnBlur={this.handleBlur}
                error={formControl.companyName ? formControl.companyName.error : ''}
              />
            </div>
            <div className={css.dotMcWrap}>
              <div className={css.dotTitle}>DOT/MC</div>
              <div className={cs(css.comIdNumWrap)}>
                <div className={css.dotWrap}>
                  <span
                    onClick={this.changeDotOrMC}
                    className={this.state.showDotInput ? cs(css.dotActive) : ''}
                  >DOT</span>
                  <span
                    onClick={this.changeDotOrMC}
                    className={this.state.showDotInput ? '' : cs(css.dotActive)}
                  >MC</span>
                </div>
                <div className={css.strenchInput}>
                  {this.state.showDotInput
                    ? <Input
                      mods={['strench']}
                      label={'companyDot'}
                      type='dot'
                      defaultValue={formData.companyDot || ''}
                      fnChange={this.handleBlur}
                      fnBlur={this.blurDotMc}
                      error={formControl.companyDot ? formControl.companyDot.error : ''}
                    />
                    : <Input
                      mods={['strench']}
                      label={'companyMc'}
                      type='mc'
                      defaultValue={formData.companyMc || ''}
                      fnChange={this.handleBlur}
                      fnBlur={this.blurDotMc}
                      error={formControl.companyMc ? formControl.companyMc.error : ''}
                    />
                  }
                </div>
              </div>
            </div>

            <div className={cs(sharedCss.check, css.check)}>
              <div
                className={cs(css.checkBox, this.state.haveRead && css.checkedBorder)}
                onClick={this.changeReadValue}
              >
                <span className={this.state.haveRead && css.chckedStyle} />
              </div>
              <p>
                I have read and accept the{' '}
                <a target='_blank' href='/terms-of-service'>Terms of Service</a>{' '}
                and{' '}
                <a target='_blank' href='/privacy-policy'>Privacy Policy</a>.</p>
              {this.state.readError && <span className={sharedCss.errorTips}>{this.state.readError}</span>}
            </div>
            <div className={sharedCss.btnWrap}>
              {(this.state.haveRead
                && (formData.companyDot || formData.companyMc)
                && formData.companyName
                && formData.basicFirstName
                && formData.basicLastName
                && formData.basicPhone
                && formData.basicIdentity)
                ? (<Button
                  onClick={this.gotToNext}
                  className={cs(sharedCss.marginLef, sharedCss.wide)}
                  mods={['large', 'action']}
                >Next</Button>)
                : (<Button
                  onClick={this.gotToNext}
                  className={cs(sharedCss.marginLef, sharedCss.wide)}
                  mods={['large']}
                >Next</Button>)
              }
            </div>
          </form>
        </div>
      </div>
    );
  }

  initPageData() {
    const user = this.props.user;
    // 判断当前会员级别 展示会员提示卡(h5)才展示
    const accountObj = this.props.account;
    let level = this.props.parentState.query && this.props.parentState.query.level ? accountObj[this.props.parentState.query.level] : accountObj.accountLevel;

    const initFormData = {
      companyMc: user.mc || '',
      companyDot: user.dot || '',
      companyName: user.companyName || '',
      basicFirstName: user.firstName || '',
      basicLastName: user.lastName || '',
      basicPhone: formatPhone(user.phone) || '',
      basicIdentity: user.identity || '',
    };

    const data = Object.assign(initFormData, this.props.parentState.formData.step1.formData);
    this.setState({
      showDotInput: !(initFormData.companyMc && !initFormData.companyDot),
      haveRead: this.props.parentState.formData.step1.haveRead || false,
      productList: level <= 2 ? productListConfig[0] : productListConfig[parseInt(level) - 2],
      formData: data,
    });
  }

  gotToNextRoute() {
    // 判断是否是主会员(主会员才给续费购买);
    const accountUserID = this.props.hp.accountBuyerInfo.data
      ? this.props.hp.accountBuyerInfo.data.accountUserId
      : null;
    const currentUserID = this.props.user.id;
    let canBuy = accountUserID ? (accountUserID == currentUserID ? true : false) : true;

    if (!canBuy) {
      const contText = `Please contact your administrator for the upgrade.`;
      store.dispatch(toastChange(
        'payment-process', contText));
    } else {
      this.props.changeStep(this.state.currentStep + 1);
      setTimeout(() => {
        this.props.setStepData(this.state.currentStep, this.state);
        store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
      }, 500);
    }
  }

  processDataAndSetState(typeName, errorTips, inputVal, clickType) {
    this.setState({
      formData: {
        ...this.state.formData,
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }

  regData(inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) {
    if (!inputVal) {
      return this.processDataAndSetState(typeName, emptyErrorTips, inputVal, true);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(typeName, wrongErrorTips, inputVal, true);
    }
    return this.processDataAndSetState(typeName, '', inputVal, false);
  }

  formatData(name, type, inputVal) {
    switch (type) {
      case 'text': {
        return this.regData(
          inputVal,
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name);
      }
      case 'zip': {
        return this.regData(
          inputVal,
          errorInfoConfig.zip.empty,
          errorInfoConfig.zip.wrong,
          regZip,
          name);
      }
      case 'email': {
        return this.regData(
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name);
      }
      case 'phone': {
        return this.regData(
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name);
      }
      case 'dot': {
        return this.regData(
          formatNumberOnly(inputVal, 7),
          errorInfoConfig.dot.empty,
          errorInfoConfig.dot.wrong,
          regDot,
          'companyDot');
      }
      case 'mc': {
        return this.regData(
          formatNumberOnly(inputVal, 6),
          errorInfoConfig.mc.empty,
          errorInfoConfig.mc.wrong,
          regMc,
          'companyMc');
      }
    }
    return null;
  }

  formatAsyncDotMcData(name, type, inputVal) {
    switch (type) {
      case 'dot': {
        if (!regDot.test(inputVal)) {
          return this.regData(
            formatNumberOnly(inputVal, 7),
            errorInfoConfig.dot.empty,
            errorInfoConfig.dot.wrong,
            regDot,
            'companyDot');
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/dot/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: inputVal,
              companyMc: res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber
                ? res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber.slice(2)
                : '',
              companyName: res.identity.legalName,
            };
            this.regData(
              data.companyDot,
              '',
              '',
              false,
              'companyDot');
            this.regData(
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'companyName');
            this.regData(
              data.companyMc,
              '',
              '',
              false,
              'companyMc');
          })
          .catch(() => {
            this.processDataAndSetState(name, errorInfoConfig.dot.wrong, inputVal, true);
          });
      }
      case 'mc': {
        if (!regMc.test(inputVal)) {
          return this.regData(
            formatNumberOnly(inputVal, 6),
            errorInfoConfig.mc.empty,
            errorInfoConfig.mc.wrong,
            regMc,
            'companyMc');
        }
        return window.fetch(`https://api.truckerpath.com/services/saferwatch/mc/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: res['CarrierService.CarrierLookup'].CarrierDetails.dotNumber['#text'],
              companyMc: inputVal,
              companyName: res.identity.legalName,
            };
            this.regData(
              data.companyDot,
              '',
              '',
              false,
              'companyDot');
            this.regData(
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'companyName');
            this.regData(
              data.companyMc,
              '',
              '',
              false,
              'companyMc');
          })
          .catch(() => {
            this.processDataAndSetState(name, errorInfoConfig.mc.wrong, inputVal, true);
          });
      }
    }
    return null;
  }

  handleBlur(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);
    this.formatData(name, type, inputVal);
  }

  blurDotMc(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);
    this.formatAsyncDotMcData(name, type, inputVal);
  }

  filterEmptyInputVal(formData) {
    let emptyValue = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key] && key !== 'companyMc') {
        if (key === 'basicPhone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: true,
          };
          return;
        }
        if (key === 'companyDot' || key === 'companyMc') {
          if (!formData.companyDot && !formData.companyMc && this.state.showDotInput) {
            emptyValue.companyDot = {
              error: errorInfoConfig.dot.empty,
              onClick: true,
            };
            emptyValue.companyMc = {
              error: '',
              onClick: false,
            };
          }
          if (!formData.companyDot && !formData.companyMc && !this.state.showDotInput) {
            emptyValue.companyMc = {
              error: errorInfoConfig.dot.empty,
              onClick: true,
            };
            emptyValue.companyDot = {
              error: '',
              onClick: false,
            };
          }
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: true,
        };
        return;
      }
    });
    return emptyValue;
  }

  canClickOrNot(formControl) {
    let emptyValue = [];
    Object.keys(formControl).forEach((key, index) => {
      if (key === ('companyMc' || 'companyDot')) {
        if (formControl.companyMc.onClick && formControl.companyDot.onClick) {
          emptyValue[index] = false;
        } else {
          emptyValue[index] = true;
        }
      } else if (formControl[key].onClick) {
        emptyValue[index] = false;
      } else if (formControl[key].onClick === false) {
        emptyValue[index] = true;
      }
    });
    if (!includes(emptyValue.toString(), 'false') && this.state.haveRead) {
      return true;
    }
    return false;
  }

  gotToNext() {
    track('payment', {'basic info -1': 1});
    const formData = this.state.formData;
    const formControl = this.state.formControl;
    let emptyValue = this.filterEmptyInputVal(formData);
    if (isEmpty(emptyValue) && this.canClickOrNot(formControl)) {
      return this.gotToNextRoute();
    }
    const controlData = Object.assign(this.state.formControl, emptyValue);

    return this.setState({
      readError: this.state.haveRead ? '' : errorInfoConfig.readTerms.empty,
      formControl: controlData,
    });
  }

  handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  }

  changeDotOrMC(e) {
    const innerText = e.target.innerText;
    const showDot = (innerText === 'DOT');
    this.setState({
      showDotInput: showDot,
    });
  }

  changeReadValue() {
    this.setState({
      haveRead: !this.state.haveRead,
      readError: this.state.haveRead ? errorInfoConfig.readTerms.empty : '',
    });
  }
}

export default BasicInformation;




// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/BasicInformation/index.js